/**
 * SocialXIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SocialXIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M19.804 2.36a.85.85 0 0 1 1.183 1.22l-6.641 7.144 7.334 9.766a.851.851 0 0 1-.68 1.36h-4.482a.85.85 0 0 1-.68-.339l-5.147-6.854-6.432 6.922-.063.061a.85.85 0 0 1-1.182-1.219l6.64-7.145L2.32 3.51A.851.851 0 0 1 3 2.151h4.483a.85.85 0 0 1 .68.339l5.146 6.853 6.432-6.922zm-2.861 17.79h2.356l-6.724-8.952-.04-.054L7.057 3.85H4.7z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const SocialXIcon = makeIcon('SocialXIcon', SocialXIconSvg)
